
import { HDNode } from '@ethersproject/hdnode';
import { ethers } from 'ethers';
import { Options, Vue } from 'vue-class-component';
import { $wallet } from '../services';

//
// btc specific
// https://forum.stacks.org/t/how-to-sign-data-with-app-private-key/6603

const bitcoin = require('../../bitcoinjs-lib');

@Options({
  components: {
  },
})
export default class Wallets extends Vue {

  mnemonic = "";
  wallets:HDNode[]|any[] = [];
  services:HDNode[]|any[] = [];
  pension:HDNode[]|any[] = [];

  // - monero = 128
  // - eth = 60
  // - btc = 0
  // address type (Legacy, P2HS Segwit, P2WPKH Segwit) 
  // FIXME config should be centralized 
  // P2PK: "Pay To Public Key"
  // P2SH: "Pay To Script Hash"
  // P2PKH:Legacy is the original bitcoin address (1...)
  // P2PSH: Nested SegWit is an improvement on Legacy (3...); they have a 40% lesser transaction sizes
  // P2WPKH: Native SegWit (Bech32): SegWit, short for Segregated Witness (bc1...), has a 80% smaller transaction sizes
  // https://bitcoin.stackexchange.com/questions/64733/what-is-p2pk-p2pkh-p2sh-p2wpkh-eli5
  // https://www.quora.com/Can-you-differentiate-between-a-Bitcoin-and-an-Ethereum-address
  derivationOptions: any = {
    btc : {
      index: 0,
      path: "m/44'/0'/0'/0",
      b58:true
    },
    segwit : {
      index: 1,
      path: "m/84'/0'/0'/0",
      b58:true
    },
    eth : {
      index: 2,
      path: "m/44'/60'/0'/0",
      b58:false
    },
    monero : {
      index: 3,
      path: "m/44'/128'/0'/0",
      b58:true
    }
  };

  defaultDerivation = this.derivationOptions.btc;


  get isValidMnemonic() {
    return $wallet.isValidMnemonic(this.mnemonic);
  }


  async mounted() {
    //
    // FOR demon only
    this.mnemonic = $wallet.memoryMnemonic || '';
    if(this.mnemonic.length) {
      this.createWallets();
    }
  }

  //
  // filter for address
  address(string: string) {
    return string;
  }

  async createWallets() {
    if(!this.isValidMnemonic){
      return;
    }

    const network = (wallet:HDNode) => {
      const privateKey = ethers.utils.arrayify(wallet.privateKey);
      const keyPair = bitcoin.ECPair.fromPrivateKey(Buffer.from(privateKey));    
      switch(this.defaultDerivation.index){
        case 0:// P2PK et P2PKH
        return { 
          address:bitcoin.payments.p2pkh({ pubkey: keyPair.publicKey }).address,
          pubicKey:keyPair.publicKey.toString('hex'),
          privateKey:keyPair.toWIF()
        };
        case 1:
        return { 
          address:bitcoin.payments.p2wpkh({ pubkey: keyPair.publicKey }).address,
          pubicKey:keyPair.publicKey.toString('hex'),
          privateKey:keyPair.toWIF()
        };
        default:
        return wallet;
      }
    };

    const seed= await $wallet.getSeed(this.mnemonic);
    this.services = $wallet.createRootKey(seed,this.defaultDerivation, 10,0).map(network);
    this.wallets = $wallet.createRootKey(seed,this.defaultDerivation, 10,5).map(network);
    this.pension = $wallet.createRootKey(seed,this.defaultDerivation, 10,10).map(network);
    return;
  }

  async updateMnemonic($event:any) {
    this.mnemonic = $event.target.value;

    //
    // FOR demo only
    $wallet.memoryMnemonic = this.mnemonic;

    await this.createWallets();
  }

  async onDerivation(token: string) {
    this.defaultDerivation = this.derivationOptions[token] || this.derivationOptions.btc;
    this.createWallets()
  }
}
